export default __webpack_public_path__ + "static/media/time_preview.98d5b7c4.jpg";